<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12" v-if="businesses.length > 1">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4 col-xl-4 mr-4">
          <div class="form-group has-label">
            <label>{{ `${$t('sigatoka.ages_to_evaluate')}: ` }} </label>
            <br />
            <el-select
              multiple
              clearable
              filterable
              size="large"
              collapse-tags
              :multiple-limit="3"
              v-model="model.age"
              :placeholder="`${$t('common_words.select')}...`"
              :class="`select-primary custom-width-select shadow-sm required-ages`"
            >
              <el-option
                v-for="option in getAges"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.id"
                :disabled="option.disabled"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group has-label">
            <label>{{ `${$t('sigatoka.leaves_to_evaluate')}: ` }} </label>
            <br />
            <el-select
              multiple
              clearable
              filterable
              size="large"
              collapse-tags
              v-model="model.leaf"
              :placeholder="`${$t('common_words.select')}...`"
              :class="`select-primary custom-width-select shadow-sm required-leaves`"
            >
              <el-option
                v-for="option in getLeafs"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.id"
              >
              </el-option>
            </el-select>
          </div>
          <br />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { isset } from 'src/util/Util';
import { Axios } from 'src/class/Axios.js';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinPermissions from 'src/util/mixinPermissions';
import Businesses from 'src/components/Selects/Businesses.vue';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinForm,
    MixinDialog,
    MixinLoading,
    MixinRerender,
    MixinPermissions,
    MixinValidations,
  ],
  components: {
    [Businesses.name]: Businesses,
  },
  computed: {
    getAges() {
      return [
        {
          id: '1',
          value: 0,
          label: this.$t('sigatoka.expecting'),
        },
        {
          id: '2',
          value: 1,
          label: this.$t('sigatoka.newly_given_birth'),
        },
        {
          id: '3',
          value: 2,
          label: '2 ' + this.$t('common_words.weeks'),
        },
        {
          id: '4',
          value: 3,
          label: '3 ' + this.$t('common_words.weeks'),
        },
        {
          id: '5',
          value: 4,
          label: '4 ' + this.$t('common_words.weeks'),
        },
        {
          id: '6',
          value: 5,
          label: '5 ' + this.$t('common_words.weeks'),
        },
        {
          id: '7',
          value: 6,
          label: '6 ' + this.$t('common_words.weeks'),
        },
        {
          id: '8',
          value: 7,
          label: '7 ' + this.$t('common_words.weeks'),
        },
        {
          id: '9',
          value: 8,
          label: '8 ' + this.$t('common_words.weeks'),
        },
        {
          id: '10',
          value: 9,
          label: '9 ' + this.$t('common_words.weeks'),
        },
        {
          id: '11',
          value: 10,
          label: '10 ' + this.$t('common_words.weeks'),
        },
        {
          id: '12',
          value: 11,
          label: '11 ' + this.$t('common_words.weeks'),
        },
        {
          id: '13',
          value: 12,
          label: '12 ' + this.$t('common_words.weeks'),
        },
        {
          id: '14',
          value: 13,
          label: '13 ' + this.$t('common_words.weeks'),
        },
        {
          id: '15',
          value: 14,
          label: '14 ' + this.$t('common_words.weeks'),
        },
        {
          id: '16',
          value: 15,
          label: '15 ' + this.$t('common_words.weeks'),
        },
      ];
    },
    getLeafs() {
      return [
        { id: '1', value: 1, label: this.$t('sigatoka.leaf') + ' 1' },
        { id: '2', value: 2, label: this.$t('sigatoka.leaf') + ' 2' },
        { id: '3', value: 3, label: this.$t('sigatoka.leaf') + ' 3' },
        { id: '4', value: 4, label: this.$t('sigatoka.leaf') + ' 4' },
        { id: '5', value: 5, label: this.$t('sigatoka.leaf') + ' 5' },
        { id: '6', value: 6, label: this.$t('sigatoka.leaf') + ' 6' },
        { id: '7', value: 7, label: this.$t('sigatoka.leaf') + ' 7' },
        { id: '8', value: 8, label: this.$t('sigatoka.leaf') + ' 8' },
        { id: '9', value: 9, label: this.$t('sigatoka.leaf') + ' 9' },
        { id: '10', value: 10, label: this.$t('sigatoka.leaf') + ' 10' },
        { id: '11', value: 11, label: this.$t('sigatoka.leaf') + ' 11' },
        { id: '12', value: 12, label: this.$t('sigatoka.leaf') + ' 12' },
        { id: '13', value: 13, label: this.$t('sigatoka.leaf') + ' 13' },
        { id: '14', value: 14, label: this.$t('sigatoka.leaf') + ' 14' },
        { id: '15', value: 15, label: this.$t('sigatoka.leaf') + ' 15' },
        { id: '16', value: 16, label: this.$t('sigatoka.leaf') + ' 16' },
        { id: '17', value: 17, label: this.$t('sigatoka.leaf') + ' 17' },
        { id: '18', value: 18, label: this.$t('sigatoka.leaf') + ' 18' },
        { id: '19', value: 19, label: this.$t('sigatoka.leaf') + ' 19' },
        { id: '20', value: 20, label: this.$t('sigatoka.leaf') + ' 20' },
      ];
    },
  },
  data() {
    return {
      businesses: [],
      businesses_id: [],
      disabledField: false,
      businessesInitial: [],
      model: {
        id: null,
        age: [],
        leaf: [],
        age_ids: [],
        leaf_ids: [],
        businesses_id: [],
        businesses_names: [],
        sigatoka_config_id: null,
      },
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          }
          if (!isset(this.model.age)) {
            return this.validationInputsRequired('ages');
          }
          if (!isset(this.model.leaf)) {
            return this.validationInputsRequired('leaves');
          }
          this.$emit('addEdit', this.model);
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (
      this.businesses &&
      this.businesses.length === 1 &&
      this.model.businesses_id.length === 0
    ) {
      this.model.businesses_id.push(this.businesses[0].id);
    }
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, sigatoka_config_leaves, sigatoka_config_ages } = editForm;
      this.model = {
        ...this.model,
        id,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sigatoka_config_ages.forEach((ages) => {
        this.model.age.push(ages.age);
        this.model.age_ids.push(ages.id);
        this.model.sigatoka_config_id = ages.sigatoka_config_id;
      });
      sigatoka_config_leaves.forEach((leaves) => {
        this.model.leaf.push(leaves.leaf);
        this.model.leaf_ids.push(leaves.id);
      });
      businesses.forEach((bs) => {
        this.businesses_id.push(bs.id);
      });
      sessionStorage.removeItem('editForm');
    }
  },
  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([Axios.getMasters('businesses/normal')])
        .then(([responseBusinesses]) => {
          this.businesses = responseBusinesses.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    } else this.showHideLoading();
  },
};
</script>
